import { ImageEmbed } from '@bnnvara/embeds';
import { GridItem } from '@bnnvara/grids';
import PropTypes from 'prop-types';
import React from 'react';

import getSourceSetValues from '../helpers/getSourceSetValues';
import resizeImageSource, {
  resizeImageSourceMax,
} from '../helpers/resizeImageSource';

const ComposableImage = ({ url, ...props }) => (
  <GridItem
    fullWidthItemSm
    columnStartSm="1"
    columnEndSm="span 12"
    columnStartMd="2"
    columnEndMd="span 10"
    columnStartLg="3"
    columnEndLg="11"
  >
    <ImageEmbed
      isLazyLoaded
      src={resizeImageSourceMax(url)}
      srcLowQuality={resizeImageSource(url, 5, 16 / 9)}
      srcSet={getSourceSetValues(url).join(', ')}
      {...props}
    />
  </GridItem>
);

ComposableImage.propTypes = {
  url: PropTypes.string.isRequired,
};

export default ComposableImage;
